<template>
  <div class="graylight-bg pr z-0" id="service-compos">
    <div
      v-observe-visibility="wrapperMaskVisible"
      class="wi-2 transition-lenear ht-100x black-bg pa tp-0 lf-0 z-0"></div>
    <div class="wrapper pr service-box z-1">
      <div
         v-show="screenWidth<=768" class="pb-50 pt-20 white fs-32 dis-ib fw-600 serif">{{info.service_title}}
        <div class="default-font dis-ib fs-16 pr white lf--2">
          服务
        </div>
      </div>
      <div
         v-show="screenWidth>768"
        :style="'left: '+leftPostion+'px;'"
        :class="showTitle ? 'visible-anime' : 'hidden-anime'"
        class="white service-title dis-ib pf lf-0 fw-600 serif">
        {{info.service_title}}
        <div class="default-font dis-ib fs-15 lh-16 pr lf--10 white">服<br>务</div>
      </div>
      <el-row>
        <el-col :span="12" v-show="screenWidth>768">
          <span class="op-0">xx</span>
        </el-col>
        <el-col :span="screenWidth<=768?24:12">
          <div v-observe-visibility="visibilityChanged" class="white pr op-0 rt--100 transition-lenear service-item" v-for="(n,idx) in serviceList" :key="idx">
            <div class="pr z-0">
              <span class="service-item-icon pr z-0">
                <fo-iconSvg1 ref="iconSvg1" class="lf--10" v-if="idx === 0"></fo-iconSvg1>
                <fo-iconSvg3 ref="iconSvg3" class="lf--6" v-else-if="idx === 1"></fo-iconSvg3>
                <fo-iconSvg2 ref="iconSvg2" class="lf--2" v-else-if="idx === 2"></fo-iconSvg2>
                <fo-iconSvg4 ref="iconSvg4" class="lf--12" v-else></fo-iconSvg4>
              </span>
            </div>
            <div class="service-item-title serif">{{n.title}}</div>
            <div class="service-item-content fw-400 op-8">{{n.content}}</div>
          </div>
        </el-col>
      </el-row>
    </div>
    <div v-show="screenWidth>768" class="pa wi-100x ht-100x tp-0 of-h lf-0">
      <div :style="'width: '+circleWidth+'px;height: '+circleWidth+'px;top: '+circleTop+'px;'" class="what-we-do"></div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
export default {
  name: 'Service',
  props: [
    'showTitle'
  ],
  data () {
    return {
      circleWidth: 0,
      serviceList: [],
      circleTop: 0,
      info: {}
    }
  },
  computed: {
    ...mapGetters([
      'scrollTop',
      'screenWidth',
      'screenHeight',
      'businessCope',
      'scrollHeight',
      'textInfo'
    ]),
    leftPostion () {
      let res = 0
      if (this.screenWidth < 1500 && this.screenWidth >= 1200) {
        res = (this.screenWidth - 1080) / 2
      } else if (this.screenWidth >= 1200) {
        res = (this.screenWidth - 1200) / 2
      } else {
        res = 50
      }
      return res
    }
  },
  watch: {
    businessCope (val) {
      if (val) {
        this.serviceList = this.$.s2o(val)
        this.$.s('businessCopeInfo', val)
      }
    },
    textInfo (val) {
      if (val) {
        this.info = this.$.s2o(val)
        this.$.s('textInfo', val)
      }
    },
    scrollTop (val) {
      if (this.screenWidth < 1920) {
        this.circleWidth = (this.scrollHeight - 30) * 50
      } else {
        this.circleWidth = (this.scrollHeight - 30) * 60
      }
      this.circleTop = (this.scrollHeight - 20) * 5
    }
  },
  mounted () {
    // 如果缓存有数据就在缓存取
    if (this.$.g('businessCopeInfo')) {
      this.serviceList = this.$.s2o(this.$.g('businessCopeInfo'))
    }
    if (this.$.g('textInfo')) {
      this.info = this.$.s2o(this.$.g('textInfo'))
    }
  },
  methods: {
    wrapperMaskVisible (isVisible, entry) {
      if (isVisible) {
        entry.target.style.width = '100%'
      }
    },
    visibilityChanged (isVisible, entry) {
      if (isVisible) {
        entry.target.style.right = '0'
        entry.target.style.opacity = '1'
      }
    }
  }
}
</script>

<style>
.service-box {
  padding-top: 2em;
  padding-left: 20px;
  padding-right: 20px;
}
.service-title {
  font-size: 3.75em;
}
.service-item {
  margin-bottom: 3em;
}
.service-item-icon {
  font-size: 3em;
}
.service-item-title {
  font-size: 1.6em;
  font-weight: 600;
  margin-bottom: 0.5em;
}
.service-item-content {
  font-size: 14px;
  padding-right: 20%;
  line-height: 26px;
  margin-bottom: 20px;
}
@media screen and (min-width: 768px) and (max-width: 992px) {
  .service-box {
    padding-top: 90px;
  }
  .service-title {
    font-size: 48px;
  }
  .service-item {
    margin-bottom: 90px;
  }
  .service-item-icon {
    font-size: 65px;
  }
  .service-item-title {
    font-size: 28px;
    font-weight: 600;
    margin-bottom: 18px;
  }
  .service-item-content {
    font-size: 16px;
  }
}
@media screen and (min-width: 992px) and (max-width: 1200px) {
  .service-box {
    padding-top: 100px;
  }
  .service-title {
    font-size: 52px;
  }
  .service-item {
    margin-bottom: 100px;
  }
  .service-item-icon {
    font-size: 70px;
  }
  .service-item-title {
    font-size: 32px;
    font-weight: 600;
    margin-bottom: 18px;
  }
  .service-item-content {
    font-size: 16px;
  }
}
@media screen and (min-width: 1200px) and (max-width: 1920px) {
  .service-box {
    padding-top: 110px;
  }
  .service-title {
    font-size: 56px;
  }
  .service-item {
    margin-bottom: 110px;
  }
  .service-item-icon {
    font-size: 75px;
  }
  .service-item-title {
    font-size: 38px;
    font-weight: 600;
    margin-bottom: 19px;
  }
  .service-item-content {
    font-size: 14px;
    padding-right: 24%;
  }
  .what-we-do {
    display: inline-block;
    width: 100px;
    height: 100px;
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    margin: auto;
    border-radius: 100%;
    background-color: #ffffff;
    opacity: 0.02;
    transition: all .1s linear;
  }
}
@media screen and (min-width: 1920px) {
  .service-box {
    padding-top: 120px;
  }
  .service-title {
    font-size: 60px;
  }
  .service-item {
    margin-bottom: 120px;
  }
  .service-item-icon {
    font-size: 80px;
  }
  .service-item-title {
    font-size: 46px;
    font-weight: 600;
    margin-bottom: 40px;
  }
  .service-item-content {
    font-size: 16px;
    line-height: 30px;
    padding-right: 24%;
  }
  .what-we-do {
    display: inline-block;
    width: 100px;
    height: 100px;
    position: absolute;
    left: 0;
    right: 0;
    margin: auto;
    border-radius: 100%;
    background-color: #ffffff;
    opacity: 0.02;
    transition: all .1s linear;
  }
}
</style>



// WEBPACK FOOTER //
// src/compos/Service.vue